module.exports = __webpack_public_path__ + "static/media/promo-code-x.78ad4e9d.svg";